'use strict';

const React = require('react'),
    {t} = require('services/i18nextWrapper'),
    AdminScaffolding = require('components/Commons/AdminScaffolding/AdminScaffolding'),
    Loading = require('components/Commons/Loading/Loading'),
    NavigationUtils = require('utils/NavigationUtils'),
    AdminScaffoldingTable = require('components/Commons/AdminScaffolding/AdminScaffoldingTable/AdminScaffoldingTable'),
    AdminScaffoldingContextHolder = require('components/Commons/AdminScaffolding/AdminScaffoldingContextHolder'),
    FormGroupTextfield = require('components/Commons/BasicForm/FormGroupTextfield/FormGroupTextfield'),
    FormGroupDropdown = require('components/Commons/BasicForm/FormGroupDropdown/FormGroupDropdown'),
    FormGroupButton = require('components/Commons/BasicForm/FormGroupButton/FormGroupButton'),
    Authentication = require('services/Security').Authentication,
    AppConstants = require('constants/AppConstants'),
    InventoryStore = require('stores/InventoryStore'),
    get = require('lodash/object').get,
    { Navigation } = require('react-router'),
    ga = require('react-ga');

let VendorContactAdmin = React.createClass({displayName: "VendorContactAdmin",
    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],

    getInitialState() {
        return {
            isEditMode: false,
            selectedVendor: null,
            companyName: NavigationUtils.getQueryParam('companyName')
        };
    },

    componentDidMount() {
        this.fetchVendor();
        ga.pageview('/vendor-contact-admin');
    },

    fetchVendor() {
        const self = this;
        const vendorId = NavigationUtils.getPathParam('vendors');
        InventoryStore.fetchVendorContacts(vendorId, function(contacts) {
            self.setState({
                contacts
            });
        });
    },

    _backToVendor() {
        this.transitionTo('/vendors');
    },

    _onDeleteContact(contactId, onSuccess, onFailure) {
        const vendorId = get(this.state, 'selectedItem.vendor.id');
        InventoryStore.deleteVendorContact(
            vendorId,
            contactId,
            onSuccess,
            onFailure
        );
    },

    _goToAddress() {
        const vendorId = NavigationUtils.getPathParam('vendors');
        const companyName = NavigationUtils.getQueryParam('companyName');
        this.transitionTo('/vendors/:vendorId/addresses', {vendorId}, {companyName});
    },

    _goToSetItems() {
        const vendorId = NavigationUtils.getPathParam('vendors');
        const companyName = NavigationUtils.getQueryParam('companyName');
        this.transitionTo('/vendors/:vendorId/items', {vendorId}, {companyName});
    },

    _onChangeContact(contact, onSuccess, onFailure) {
        InventoryStore.changeVendorContact(
            NavigationUtils.getPathParam('vendors'),
            contact,
            onSuccess,
            onFailure
        );
    },

    _onAddContact(contact, onSuccess, onFailure) {
        InventoryStore.addVendorContact(
            NavigationUtils.getPathParam('vendors'),
            contact,
            onSuccess,
            onFailure
        );
    },

    _onRowSelection(
        item,
        itemIndex,
        lastRowScrollPosition,
        headerActiveFilters
    ) {
        this.setState(
            {
                selectedItem: item,
                isEditMode: !!item,
                headerActiveFilters
            },
            () => {
                // stay the position of the scroll after row select when
                // the offset is outside of initial viewport page.
                this.getDOMNode().querySelector(
                    '.mui-body-table'
                ).scrollTop = lastRowScrollPosition;
            }
        );
    },

    _onEnterPress() {
        if (this.onEnterKeyDown) {
            this.onEnterKeyDown();
        }
    },

    _addEnterKeyDown(onEnterKeyDown) {
        this.onEnterKeyDown = onEnterKeyDown;
    },

    _onCancel() {
        this.setState({
            selectedItem: null
        });
    },

    _getBreadcrumbLinks() {
        return [
            { link: 'vendors', displayName: t('dashboard_sidebar_suppliers') },
            { displayName: get(this.state, 'companyName') }
        ];
    },

    render() {
        let { contacts, selectedItem, isEditMode } = this.state;
    
        if (!contacts) {
            return React.createElement(Loading, null);
        } else {
    
            const currentSelectedSection = selectedItem && selectedItem.type
              ? AppConstants.getContactMapping(t)[selectedItem.type]
              : '';
    
            const currentSelectedValueHydrated = currentSelectedSection
              ? Object.assign({}, selectedItem, {displayText: currentSelectedSection})
              : selectedItem;
            
            const messages = {
                changeSuccessMessage: t('vendor_contact_change_success_message'),
                changeFailureMessage: t('vendor_contact_change_failure_message'),
                deleteSuccessMessage: t('vendor_contact_delete_success_message'),
                addSuccessMessage: t('vendor_contact_add_success_message'),
                addFailureMessage: t('vendor_contact_add_failure_message')
            };
            let contextHolder = this.getContextHolderInstance();

            const additionalButtons = [
                {
                    type: 'CHANGE',
                    permission: 'NEW',
                    el: (
                        React.createElement(FormGroupButton, {
                            label: t('back'), 
                            icon: "subdirectory_arrow_left", 
                            type: "icon", 
                            onClick: this._backToVendor}
                        )
                    )
                },
                {
                    type: 'NEW',
                    permission: 'NEW',
                    el: React.createElement(FormGroupButton, {
                      label: t('back'), 
                      icon: "subdirectory_arrow_left", 
                      type: "icon", 
                      onClick:  this._backToVendor}
                    )
                },
                {
                    type: 'NEW',
                    permission: 'NEW',
                    el: React.createElement(FormGroupButton, {
                      label: t('vendor_admin_label_set_address'), 
                      icon: "subdirectory_arrow_left", 
                      type: "icon", 
                      onClick:  this._goToAddress}
                    )
                },
                {
                    type: 'NEW',
                    permission: 'NEW',
                    el: React.createElement(FormGroupButton, {
                      label: t('vendor_admin_set_items'), 
                      icon: "subdirectory_arrow_left", 
                      type: "icon", 
                      onClick:  this._goToSetItems}
                    )
                }
            ];

            const formFieldsEl = [
                React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "name", 
                    isRequired: true, 
                    isRelaxedText: true, 
                    name: t('label_name'), 
                    value: selectedItem, 
                    label: t('vendor_contact_label_contact_name'), 
                    isEditMode: isEditMode, 
                    onEnter: this._onEnterPress}
                ),
                React.createElement(FormGroupDropdown, {
                    items: AppConstants.getContacts(t), 
                    operationsHolder: contextHolder, 
                    readerAttribute: "displayText", 
                    customReaderWriterAttribute: "type", 
                    writerAttribute: "type", 
                    name: t('label_type'), 
                    label: t('vendor_contact_label_type'), 
                    value: currentSelectedValueHydrated || 'EMAIL', 
                    isRequired: true, 
                    isEditMode: isEditMode, 
                    onEnter: this._onEnterPress}
                ),
                React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "contactInfo", 
                    isRequired: true, 
                    isRelaxedText: true, 
                    name: t('vendor_contact_label_contact_info'), 
                    value: selectedItem, 
                    label: t('vendor_contact_label_contact_info'), 
                    isEditMode: isEditMode, 
                    onEnter: this._onEnterPress}
                )
            ];

            return (
                React.createElement("div", {className: "brewhouse-view"}, 
                    React.createElement(AdminScaffolding, {
                        title: t('vendor_contact_title_supplier_contacts'), 
                        moduleName: "ADMIN_VENDOR_CONTACT", 
                        messages: messages, 
                        contextHolder: contextHolder, 
                        value: selectedItem, 
                        fetchItems: this.fetchVendor, 
                        headerFields: formFieldsEl, 
                        onAdd: this._onAddContact, 
                        onAddText: t('vendor_contact_label_add'), 
                        onChange: this._onChangeContact, 
                        onCancel: this._onCancel, 
                        onDelete: this._onDeleteContact, 
                        additionalButtons: additionalButtons, 
                        addEnterKeyDown: this._addEnterKeyDown, 
                        breadcrumb: this._getBreadcrumbLinks()
                    }, 
                        React.createElement(AdminScaffoldingTable, {
                            headerActiveFilters: this.state.headerActiveFilters, 
                            onRowSelection: this._onRowSelection, 
                            value: selectedItem, 
                            filteredColumns: ['name', 'contactInfo'], 
                            sortByColumn: ['displayType'], 
                            columnNames: [
                                t('vendor_contact_label_contact_name'),
                                t('vendor_contact_label_type'),
                                t('vendor_contact_label_contact_info')], 
                            displayAttributes: ['name', 'displayType', 'contactInfo']
                        }, 
                            contacts.map(contact => {
                                contact.displayType = AppConstants.getContactMapping(t)[contact.type];
                                return contact;
                            })
                        )
                    )
                )
            );
        }
    }
});

module.exports = VendorContactAdmin;



/** WEBPACK FOOTER **
 ** ./src/views/VendorAdmin/VendorContactAdmin.js
 **/